export default __webpack_public_path__ + "static/media/Clock.45f496ce.svg";